import { TextField } from '@qbe/ads-core';
import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

import { useAppContent } from '~/hooks';

const CostcoMembershipNumberInput = <T extends FieldValues>({
  control,
  name,
}: UseControllerProps<T>) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.costcoMembershipComponent.fields.costcoMembershipNumber',
  });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, ...field }, fieldState }) => (
        <TextField
          {...field}
          inputRef={ref}
          id="costco-membership-number"
          name="costco-membership-number"
          label={getTextContent('label')}
          data-track-value="mask"
          error={fieldState.invalid}
          displayIcon
          helperText={
            fieldState.invalid ? getTextContent('invalidText') : getTextContent('helperText')
          }
          required
        />
      )}
      rules={{
        required: true,
        pattern: /^[78]\d{10}$/,
      }}
    />
  );
};

export default CostcoMembershipNumberInput;
